import client from './client';

const swaps = {
  // Listings with optional filters: status, mine ('posted'|'claimed')
  getListings:     (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return client.get(`/swaps/${qs ? `?${qs}` : ''}`);
  },
  createListing:   (data) => client.post('/swaps/', data),
  cancelListing:   (id)   => client.delete(`/swaps/${id}/`),
  claimListing:    (id)   => client.post(`/swaps/${id}/claim/`),
  approveListing:  (id)   => client.post(`/swaps/${id}/approve/`),
  rejectListing:   (id)   => client.post(`/swaps/${id}/reject/`),
  getTransactions: ()     => client.get('/swap-transactions/'),

  // SL's own upcoming shifts (for posting a swap)
  myUpcomingShifts: () => client.get('/shift-assignments/?upcoming=true'),
};

export default swaps;
